import React from 'react';
import * as mui from '@mui/material';
import { SectionHeader } from './UIComponents';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SecurityIcon from '@mui/icons-material/Security';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const ReportsView = ({ changeView }) => {
  return (
    <mui.Paper sx={{ p: 3, mb: 4 }}>
      <SectionHeader 
        title="Network Access Reports" 
        icon={<AssessmentIcon />} 
        description="Generate comprehensive network access reports" 
      />
      
      <mui.Box sx={{ mt: 4, p: 3, bgcolor: 'background.default', borderRadius: 2 }}>
        <mui.Typography variant="h6" gutterBottom>
          Available Reports
        </mui.Typography>
        
        <mui.List>
          <mui.ListItem 
            button 
            divider
            sx={{ 
              borderRadius: 1,
              mb: 1,
              '&:hover': { bgcolor: 'action.hover' } 
            }}
          >
            <mui.ListItemIcon>
              <SecurityIcon color="error" />
            </mui.ListItemIcon>
            <mui.ListItemText 
              primary="Terminated User Access Report" 
              secondary="Report on terminated users who still have network access"
            />
            <mui.Button 
              variant="outlined" 
              size="small" 
              startIcon={<FileDownloadIcon />}
              onClick={() => changeView('analysis', 'Terminated User Analysis')}
            >
              Generate
            </mui.Button>
          </mui.ListItem>
          
          <mui.ListItem 
            button 
            divider
            sx={{ 
              borderRadius: 1,
              mb: 1,
              '&:hover': { bgcolor: 'action.hover' } 
            }}
          >
            <mui.ListItemIcon>
              <AccessTimeIcon color="primary" />
            </mui.ListItemIcon>
            <mui.ListItemText 
              primary="Job Execution Summary" 
              secondary="Summary of job executions and their results"
            />
            <mui.Button 
              variant="outlined" 
              size="small" 
              startIcon={<FileDownloadIcon />}
              onClick={() => changeView('logs', 'Job History')}
            >
              Generate
            </mui.Button>
          </mui.ListItem>
          
          <mui.ListItem 
            button 
            divider
            sx={{ 
              borderRadius: 1,
              mb: 1,
              '&:hover': { bgcolor: 'action.hover' } 
            }}
          >
            <mui.ListItemIcon>
              <VerifiedUserIcon color="success" />
            </mui.ListItemIcon>
            <mui.ListItemText 
              primary="Network Access Audit" 
              secondary="Comprehensive audit of network access permissions"
            />
            <mui.Button 
              variant="outlined" 
              size="small" 
              startIcon={<FileDownloadIcon />}
            >
              Generate
            </mui.Button>
          </mui.ListItem>
        </mui.List>
      </mui.Box>
      
      <mui.Box sx={{ mt: 4, p: 3, bgcolor: 'background.default', borderRadius: 2 }}>
        <mui.Typography variant="h6" gutterBottom>
          Schedule Automated Reports
        </mui.Typography>
        
        <mui.Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Configure automated report generation and delivery to stakeholders
        </mui.Typography>
        
        <mui.Button 
          variant="contained" 
          startIcon={<ScheduleIcon />}
        >
          Configure Report Schedule
        </mui.Button>
      </mui.Box>
    </mui.Paper>
  );
};

export default ReportsView; 